unit TermListType;
{

/* Initial. */

}
interface

uses
  SysUtils,
  JS,
  TermType;

type
  TTermArray = array of TTermType;
  TStringArrayType = array of String;

  TTermListType = class
    fTermArray: TTermArray;
  public
    property TermArray: TTermArray read fTermArray;
    constructor Create(const String_JSON: String);
  end;

  function GetLanguageTermOnFieldName(const TermListType: TTermListType; const String_FieldName: String; const String_ObjectName: String): String;

implementation

constructor TTermListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    TermType: TTermType;
begin
  SetLength(fTermArray, 0);

  if String_JSON <> 'null' then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      TermType := TTermType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(TermType, fTermArray, High(fTermArray));
    end;
  end;
end;

function GetLanguageTermOnFieldName(const TermListType: TTermListType; const String_FieldName: String; const String_ObjectName: String): String;
var
  TermType: TTermType;
  Strings_EnglishTerms: TStringArrayType;
  String_LanguageTerm: String;
begin
  String_LanguageTerm := '';

  for TermType in TermListType.TermArray do
  begin
    Strings_EnglishTerms := TermType.EnglishTerm.Split(['|']);

    if Strings_EnglishTerms[0] = String_FieldName then
      if (String_ObjectName = '') or (Pos(String_ObjectName + ' ', Strings_EnglishTerms[1]) = 1) then
      begin
        String_LanguageTerm := TermType.LanguageTerm;

        Break;
      end;
  end;

  GetLanguageTermOnFieldName := String_LanguageTerm;
end;

end.
